import React, { useEffect, useState } from 'react';
import './title.css';

const Title = ({ text }) => {
    const [clientText, setClientText] = useState(text);

    useEffect(() => {
        setClientText(text.toUpperCase());
    }, [text]);

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    <h1 className='title'>{clientText}</h1>
                </div>
            </div>
        </div>
    );
}

export default Title;
